import { useState } from "react";
import { Box } from "@mui/material";

import Gatter from "../DetailGatter/Gatter";
import Line from "../DetailGatter/Line";
import Text from "../DetailGatter/Text";

export default function Halbaddierer() {
  const [a, setA] = useState(0);
  const [b, setB] = useState(0);

  const sum = a ^ b;
  const carry = a & b;

  return (
    <Box
      sx={{
        mt: 2,
        width: "95%",
        maxWidth: 700,
        mx: "auto",
      }}
    >
      <svg
        viewBox="0 0 700 200"
        height="100%"
        style={{ border: "1px solid #ccc" }}
      >
        {/* Inputs */}
        <Text x={20} y={60} text={"A "} color={a} />
        <Text x={20} y={90} text={"B "} color={b} />

        <Line
          x1={60}
          x2={200}
          y={53}
          color={a}
          position={"start"}
          handleClick={() => setA(a ? 0 : 1)}
        />
        <Line
          x1={60}
          x2={200}
          y={82}
          color={b}
          position={"start"}
          handleClick={() => setB(b ? 0 : 1)}
        />

        {/* XOR */}
        <Gatter x={200} y={40} text={"XOR"} />

        <Line x1={170} x2={200} y={53} y2={135} color={a} position={"angle"} />
        <Line x1={150} x2={200} y={82} y2={155} color={b} position={"angle"} />

        <Line x1={300} x2={400} y={70} color={sum} position={"end"} />
        <Text x={425} y={77} text={"X "} color={sum} />

        {/* AND */}
        <Gatter x={200} y={110} text={"AND"} />

        <Line x1={300} x2={400} y={140} color={carry} position={"end"} />
        <Text x={425} y={147} text={"Ü "} color={carry} />
      </svg>
    </Box>
  );
}
